/**
 * 常量
 * 
*/

export const AISLE_LOG = 'aisleLog/AISLE_LOG';
